"use client"

import type { WidgetRegistrationProps } from "@/types/types"
import { ComponentConfig } from "@measured/puck"
import { twMerge } from "tailwind-merge"
import { generateResponsiveCSS } from "../../../lib/helper"
import { WidgetRegistrationContent } from "./components/WidgetRegistrationContent"
import { useWidgetRegistration } from "./hooks/useWidgetRegistration"

export const RenderConfig: ComponentConfig<WidgetRegistrationProps> = {
  render: ({
    items,
    className,
    styles,
    responsiveType,
    id: componentId,
    title,
  }: WidgetRegistrationProps & { id?: string }) => {
    const { id } = useWidgetRegistration({
      items,
      componentId,
    })

    const mergedStyles = styles || {}
    const responsiveCSS = generateResponsiveCSS(id, mergedStyles, responsiveType || "mobileFirst")

    return (
      <>
        {responsiveCSS}
        <WidgetRegistrationContent id={id} items={items} className={twMerge(className)} title={title} isCMS={true} />
      </>
    )
  },
}
